import React, { useState } from "react";
import {
  Box,
  Button,
  Modal,
  Typography,
  TextField
} from "@material-ui/core";

import { CardUser } from "../CardUser";
import { useStyles } from "./styles";
import apiV2 from "../../../../api/api-client-v2";
import { toast } from "react-toastify";

export const ListUsersReproved = ({ users = [], setCountChangeUser }) => {
  const classes = useStyles();
  const [showModal, setShowModal] = useState(false);
  const [userId, setUserId] = useState(null);
  const [reasonDisapproval, setReasonDisapproval] = useState('');
  const [hasError, setHasError] = useState(false);

  const handleCloseModal = () => {
    setHasError(false);
    setReasonDisapproval('');
    setShowModal(false);
  };

  const handleApprove = () => {
    apiV2.post(`users/signups/${userId}/approve`).then(() => {
      setCountChangeUser(previewState => previewState + 1)
      handleCloseModal()
    }).catch((e) => {
      toast.error('Erro ao aprovar usuário!')
    })
  }

  return (
    <>
      <Box>
        <Typography className={classes.resultsText}>
          Listando {users.length} resultado{users.length !== 1 && 's' }
        </Typography>
        {users.map((user) => (
          <CardUser
            isReproved
            setUserId={setUserId}
            handleShowModal={setShowModal}
            setCountChangeUser={setCountChangeUser}
            key={user.id}
            user={user}
          />
        ))}
      </Box>
      <Modal
        className={classes.modal}
        open={!!showModal}
        onClose={handleCloseModal}
      >
        <Box className={classes.modalContainer}>
          <Typography className={classes.titleModal}>
            Deseja {showModal === "approved" ? "aprovar" : "reprovar"} o cadastro?
          </Typography>
          <Typography className={classes.textodal}>
            {showModal === "approved"
              ? "Após a aprovação, o usuário receberá um e-mail com as instruções para a ativação da conta."
              : "Caso seja reprovado, um e-mail será enviado ao usuário informando a mudança de status da solicitação de cadastro."}
          </Typography>
          {
            showModal !== "approved" && (
                <form>
                  <TextField
                    variant="filled"
                    color="primary"
                    className={classes.reasonDisapproval}
                    id="reason_disapproval"
                    value={reasonDisapproval}
                    error={!reasonDisapproval && hasError}
                    onChange={(e) => {
                      setHasError(false);
                      setReasonDisapproval(e.target?.value)
                    }}
                    data-cy='reason_disapproval'
                    label='Informe o motivo da reprovação'
                    required />
                </form>)
          }
          <Box className={classes.btnModal}>
            <Button
              className="cancel"
              onClick={handleCloseModal}
              size="large"
              variant="contained"
            >
              CANCELAR
            </Button>
            <Button
              size="large"
              onClick={() => handleApprove() }
              variant="contained"
              color="primary"
              // disabled={!reasonDisapproval}
            >
              APROVAR
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
